<template>
  <div class="edit-free-entry">
    <div class="contents disp-scroll">
      <article class="item-container">
        <p>PDF出力項目</p>
        <p class="desc">
          一覧に出力する項目を引用リストから記載してください。<br>
          1行につき1項目です。
        </p>
        <textarea
          class="textarea main-message disp-scroll"
          style="resize: none;"
          v-model="scenarioEdit.parameter.item_list"
          pattern="^[0-9A-Za-z_]+$"
          :disabled="scenarioEdit.is_confirm"
          required/>
      </article>
      <article class="item-container">
        <p>フォーマット選択</p>
        <div v-if="scenarioEdit.parameter.format_no === 0">
          <p class="desc">
            罫線なしで一覧を出力します。<br>
          </p>
        </div>
        <div v-if="scenarioEdit.parameter.format_no === 1">
          <p class="desc">
            罫線付きの表で一覧を出力します。<br>
          </p>
        </div>
        <b-select class="select output-format"
          placeholder="設定項目"
          v-model="scenarioEdit.parameter.format_no"
          :disabled="scenarioEdit.is_confirm"
        >
          <option v-for="(formatType, formatNo) in formatList" :value="formatNo" :key="formatNo">
            {{formatType}}
          </option>
        </b-select>
      </article>
      <article class="item-container">
        <p>PDFファイル名</p>
        <p class="desc">
          ロボからダウンロードするときのファイル名です。
        </p>
        <b-field>
          <b-input
            style="width: 80%;"
            v-model="scenarioEdit.parameter.file_name"
            maxlength="100"
            :disabled="scenarioEdit.is_confirm"
            required/>
          <div style="margin: 4px;">.pdf</div>
        </b-field>
      </article>
      <article class="item-container">
        <p>PDFファイル送付先</p>
        <p class="desc">
          設定したメールアドレスに、PDFファイルを添付して送付します。
        </p>
        <b-field>
          <b-input
            style="width: 80%;"
            placeholder="例：abc@xyz.com"
            v-model="scenarioEdit.parameter.send_to"
            max-length="254"
            :disabled="scenarioEdit.is_confirm"/>
          <div style="margin: 4px;">へ送信</div>
        </b-field>
      </article>
      <article class="item-container">
        <p>
          メール添付時のPDFファイル名
        </p>
        <p class="desc">
          半角英数字のみが使えます。
        </p>
        <b-field>
          <b-input
            style="width: 80%;"
            v-model="scenarioEdit.parameter.attachment_file_name"
            maxlength="100"
            pattern="^[0-9A-Za-z]+$"
            :disabled="scenarioEdit.is_confirm"/>
          <div style="margin: 4px;">.pdf</div>
        </b-field>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scenarioEdit: {
      type: Object,
    },
  },
  data () {
    return {
      /** PDFフォーマット一覧 */
      formatList: [
        '一覧',
        '一覧表'
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.edit-free-entry {
  text-align: left;
  .contents {
    background-color:white;
    height: 600px;
  }
  article {
    margin-bottom: 24px;
    text-align: left;
    .main-message {
      margin-top: 8px;
    }
    .pdf-format {
      margin-top: 8px;
    }
  }
}
.desc {
  font-size: 12px;
  color: #666;
  margin: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalContentPdfDownloadParts.vue